package com.cybersoftsolution.cybersoftsolutionweb.components.sections

import com.cybersoftsolution.cybersoftsolutionweb.models.MyElement
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources



sealed class PageSection(override var text: String,var name: String, var route: String, override var id: String?,var icon: Resources.FaIconsClassName?=null,override var visible: Boolean = true):
    MyElement() {
    data object HeaderSection : PageSection(
        text = "Inicio",
        name = "HeaderSection",
        route = "",
        id = "HeaderSectionId",
        icon = Resources.FaIconsClassName.Home_ICO,
    )
    data object AboutSection : PageSection(
        text = "Acerca de",
        name = "AboutSection",
        route = "",
        id = "AboutSectionId",
        icon = null,
    )
    data object ServicesSection : PageSection(
        text = "Servicios",
        name = "ServicesSection",
        route = "",
        id = "ServicesSectionId",
        icon = null,
    )
    data object ProjectsSection : PageSection(
        text = "Proyectos",
        name = "ProjectsSection",
        route = "",
        id = "ProjectsSectionId",
        icon = null,
    )
    data object TechnologySection : PageSection(
        text = "Tecnologías",
        name = "TechnologySection",
        route = "",
        id = "TechnologySectionId",
        icon = null,
    )
    data object CommunitySection : PageSection(
        text = "Comunidad",
        name = "CommunitySection",
        route = "",
        id = "CommunitySectionId",
        icon = null,
    )
    data object TestimonialSection : PageSection(
        text = "Testimonios",
        name = "TestimonialSection",
        route = "",
        id = "TestimonialSectionId",
        icon = null,
    )
    data object ContactSection : PageSection(
        text = "Contacto",
        name = "ContactSection",
        route = "",
        id = "ContactSectionId",
        icon = null,
    )
    data object FooterSection : PageSection(
        text = "Pie de página",
        name = "FooterSection",
        route = "",
        id = "FooterSectionId",
        icon = null,
    )
    data object NewsSection : PageSection(
        text = "Noticias",
        name = "NewsSection",
        route = "",
        id = "NewsSectionId",
        icon = null,
    )
    data object WorkFlowSection : PageSection(
        text = "Flujo de Trabajo",
        name = "WorkFlowSection",
        route = "",
        id = "WorkFlowSectionId",
        icon = null,
    )
    data object SearchSection : PageSection(
        text = "Buscar",
        name = "SearchSection",
        route = "",
        id = "SearchSectionId",
        icon = null,
    )
    data object BannerSection : PageSection(
        text = "Banner",
        name = "BannerSection",
        route = "",
        id = "BannerSectionId",
        icon = null,
    )
}


private var sections: List<PageSection> = listOf(

    PageSection.HeaderSection,
    PageSection.ServicesSection,
    PageSection.ContactSection,
    PageSection.AboutSection,
    PageSection.CommunitySection,
    PageSection.WorkFlowSection,
    PageSection.TechnologySection,
    PageSection.ProjectsSection,
    PageSection.NewsSection,
    PageSection.TestimonialSection,

)


fun getSections(): List<PageSection> {
    return sections
}

